import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
export const ConfigurationMessages = {
    Name: {
        Validation: {
            AlreadyExists: "A deployment target with this name already exists. Please choose a different name.",
            NotProvided: "Please enter a name for this deployment target",
        },
        HelperText: "A short, memorable name for this deployment target.",
    },
    EnvironmentIds: {
        Validation: {
            NotProvided: "Please select an environment for this deployment target.",
        },
        HelperText: "Choose at least one environment for this deployment target.",
    },
    MachineRoles: {
        Validation: {
            NotProvided: "Please select a role for this deployment target.",
        },
        HelperText: (<>
                <ExternalLink href={"https://oc.to/TargetRoles"}>Target roles</ExternalLink> are used as tags to select the deployment targets to execute a deployment or runbook against.
            </>),
    },
    ServerUri: {
        Validation: {
            NotProvided: "Please enter the Octopus Deploy Server URL",
            Invalid: "Please enter a valid Octopus Deploy Server URL",
        },
        HelperText: "Provide the full URL to your Octopus Deploy instance.",
    },
    ServerCommsAddress: {
        Validation: {
            NotProvided: "Please enter the Octopus Deploy Server Communications URL",
            Invalid: "Please enter a valid Octopus Deploy Server Communications URL",
        },
        HelperText: "The URL of the Octopus Server that the Agent will poll for work.",
    },
} as const;
